import { Navigate, Outlet } from 'react-router-dom'
import {isUserLoggedIn, getUserType } from '../config/userSession';

const ProtectedLandlordRoutes = () => {
return (
    isUserLoggedIn() && getUserType() === 'Landlord' ? <Outlet/> : <Navigate to='/login'/>
  )
}

export default ProtectedLandlordRoutes;